module.exports = __webpack_public_path__ + "img/habitat_3.7caaf3a2.jpg";